/**
 * Addresses as people type or paste them into an invitation (R3-4): one or several, separated
 * by spaces, commas, semicolons or new lines. Pure; the server checks each address it is sent.
 */

const SEPARATORS = /[\s,;]+/;

/** The addresses a separator has closed, and the part still being typed. */
export function splitTyped(text: string): { readonly closed: readonly string[]; readonly typing: string } {
  const parts = text.split(SEPARATORS);
  const typing = parts.pop() ?? "";
  return { closed: parts.filter((part) => part !== ""), typing };
}

/** The list with `added` after it, each address once whatever its case. */
export function withAddresses(addresses: readonly string[], added: readonly string[]): readonly string[] {
  const seen = new Set(addresses.map((address) => address.toLowerCase()));
  const result = [...addresses];
  for (const address of added) {
    if (seen.has(address.toLowerCase())) continue;
    seen.add(address.toLowerCase());
    result.push(address);
  }
  return result;
}

/** What Send sends: the closed addresses and the one still being typed. */
export function addressesToSend(addresses: readonly string[], typing: string): readonly string[] {
  return withAddresses(addresses, splitTyped(`${typing} `).closed);
}
